<p-dialog #dialog appendTo="body" header="Manage Port Access VLANs" [(visible)]="visible" [modal]="true"
		  [resizable]="true" (onHide)="onHide()" styleClass="port-access-vlan-dialog" (onShow)="onShow()"
		  [style]="{'width': '1200px', 'height': '800px', 'min-width': '625px', 'min-height': '670px'}">

	<port-access-vlan-editor [deviceGuid]="deviceGuid" [portTableHeightVh]="0" [portTableHeightPx]="portTableHeightPxProp"
							 [portTableMinHeight]="150" [visible]="visible">
	</port-access-vlan-editor>

	<p-footer>
		<button type="button" pButton icon="fa fa-times" [disabled]="false"
				(click)="onCloseClicked()" label="Close"></button>
	</p-footer>

</p-dialog>
